

































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import GiftInfo from '@/store/entities/gift-info';
import dayjs from "dayjs";

@Component
export default class EditGiftInfo extends AbpBase {
  @Prop({type: Boolean, default: false}) value: boolean;
  giftInfo: GiftInfo = new GiftInfo();
  get loading() {
    return this.$store.state.giftInfo.loading;
  }
  get permissions() {
    return this.$store.state.giftInfo.permissions
  }


  save() {
    (this.$refs.giftInfoForm as any).validate(async (valid: boolean) => {
      if (valid) {

        await this.$store.dispatch({
          type: 'giftInfo/update',
          data: this.giftInfo
        });
        (this.$refs.giftInfoForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);
      }
    })
  }

  cancel() {
    (this.$refs.giftInfoForm as any).resetFields();
    this.$emit('input', false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    } else {
      this.giftInfo = Util.extend(true, {}, this.$store.state.giftInfo.editGiftInfo);
    }
  }

  giftInfoRule = {
    giftName: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('giftName')),
      trigger: 'blur'
    }],
    giftCode: [{
      required: true,
      message: this.L('FieldIsRequired', undefined, this.L('giftCode')),
      trigger: 'blur'
    }]
  }
}
